import template from './login.template.html';
import controller from './login.controller';
import './login.scss';

export default {
  template,
  controller,
};



// WEBPACK FOOTER //
// ./src/app/login/login.component.js